import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

import iconUk from '../../../assets/image/lang/ukraine.png';
import iconEn from '../../../assets/image/lang/united-states.png';
import iconDe from '../../../assets/image/lang/germany.png';
import iconPl from '../../../assets/image/lang/poland.png';

const languages = [
  {
    code: 'uk',
    label: 'UA',
    icon: <img src={iconUk} alt="UA" className="language-icon" />,
  },
  {
    code: 'pl',
    label: 'PL',
    icon: <img src={iconPl} alt="PL" className="language-icon" />,
  },
  {
    code: 'en',
    label: 'EN',
    icon: <img src={iconEn} alt="EN" className="language-icon" />,
  },
  {
    code: 'de',
    label: 'DE',
    icon: <img src={iconDe} alt="DE" className="language-icon" />,
  },
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const currentLangCode = i18n.language || 'en';
  const defaultIndex = languages.findIndex(
    (lang) => lang.code === currentLangCode
  );
  const [activeIndex, setActiveIndex] = useState(
    defaultIndex !== -1 ? defaultIndex : 0
  );

  const switchLanguage = () => {
    const nextIndex = (activeIndex + 1) % languages.length;
    const nextLang = languages[nextIndex].code;

    i18n.changeLanguage(nextLang);
    setActiveIndex(nextIndex);
  };

  useEffect(() => {
    const currentIndex = languages.findIndex(
      (lang) => lang.code === i18n.language
    );
    if (currentIndex !== -1) setActiveIndex(currentIndex);
  }, [i18n.language]);

  return (
    <button className="language-switcher" onClick={switchLanguage}>
      {languages[activeIndex].icon} {languages[activeIndex].label}
    </button>
  );
};

export default LanguageSwitcher;
